import { Link } from "react-router-dom";

export default function NavigationBar() {
  return (
    <div>
      <header>
        <nav className="p-6">
          <div className="flex justify-between items-center">
            <img
              src="https://i.imgur.com/emX0lqN.jpg"
              className="w-60 pb-4"
              alt="tailus logo"
            />
            <div className="flex justify-between flex-grow">
              <div className="flex ml-6 items-center">
                <span>
                  <span className="text-gray-500 text-md hover:underline">
                    <Link to="/">Home</Link>
                  </span>
                </span>
                <span>
                  <span className="text-gray-500 text-md hover:underline ml-7">
                    <Link to="/products">All Products</Link>
                  </span>
                </span>
              </div>

            </div>
          </div>
        </nav>
      </header>
    </div>
  );
}
